<div class="re-px-20 re-py-25 md:re-px-30 re-xs">
  @if (tariffData?.info) {
    <div class="re-mb-15 md:re-mb-0 infotext">
      <div [innerHTML]="tariffData?.info"></div>
    </div>
  }

  @for (bonus of tariffData?.parts?.[0]?.contractPayments; track bonus) {
    <div class="re-mt-15">
      <div class="bold">{{ bonus?.description }}</div>
      <div>{{ bonus?.payment }}</div>
    </div>
  }

</div>
